import React from 'react';
import { useTranslation } from 'react-i18next';
import XIcon from '../../icons/x.svg';
import Input from '../../components/Input';

const UserDetailsPopup = ({ user, onClose }) => {
  const { t } = useTranslation();

  if (!user) return null;

  const isTechnician = user.role === 'ROLE_TECHNICIAN';

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[1050]">
      <div className="bg-white rounded-[12px] shadow-lg w-full max-w-[60%] p-8 pb-12 relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors"
        >
          <img src={XIcon} alt="Close" className="w-5 h-5" />
        </button>

        {/* Title */}
        <h2 className="text-[32px] text-[#38485C] font-semibold mb-6">
          {t('form_titles.user_details') || 'Détails de l\'utilisateur'}
        </h2>

        {/* User Details */}
        <div className="space-y-4">
          <div className="grid md:grid-cols-3 gap-6">
            {/* First Name */}
            <Input
              type="text"
              label={t('fields.users.firstName') || 'Prénom'}
              name="firstName"
              value={user.firstName || ''}
              disabled={true}
            />

            {/* Last Name */}
            <Input
              type="text"
              label={t('fields.users.lastName') || 'Nom'}
              name="lastName"
              value={user.lastName || ''}
              disabled={true}
            />

            {/* Username */}
            <Input
              type="text"
              label={t('fields.users.username') || 'Nom d\'utilisateur'}
              name="username"
              value={user.username || ''}
              disabled={true}
            />

            {/* Email */}
            <Input
              type="text"
              label={t('fields.users.email') || 'Email'}
              name="email"
              value={user.email || ''}
              disabled={true}
            />

            {/* Role */}
            <Input
              type="text"
              label={t('fields.users.role') || 'Rôle'}
              name="role"
              value={t(`roles.${user.role}`) || user.role || ''}
              disabled={true}
            />

            {/* Technician-specific fields */}
            {isTechnician && (
              <>
                {/* Secret Code */}
                <Input
                  type="text"
                  label={t('fields.users.secretCode') || 'Code secret'}
                  name="secretCode"
                  value={user.secretCode || ''}
                  disabled={true}
                />

                {/* Tech Number */}
                <Input
                  type="text"
                  label={t('fields.users.techNumber') || 'Numéro de technicien'}
                  name="workshopId"
                  value={user.workshopId || ''}
                  disabled={true}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetailsPopup;

